document.addEventListener('DOMContentLoaded', function () {
  const titleSelect = document.getElementById('titleSelect');
  const preview = document.getElementById('customMugPreview');
  const sistersOverlay = document.getElementById('sistersOverlay');
  const bestiesOverlay = document.getElementById('bestiesOverlay');
  const productMedia = document.querySelector('.product__media');
  const thumbnailSlider = document.querySelector(
  'slider-component[id^="GalleryThumbnails"]'
);


  const gallery = document.querySelector(
    '.product__media, .product__media-list, .product-gallery'
  );

  const thumbnails = document.querySelector(
    '.product__media-thumbnails, .product__media-sublist, .product__media-nav, .product-gallery__thumbnails'
  );

  if (!titleSelect || !preview || !gallery) return;

  gallery.appendChild(preview);

  titleSelect.addEventListener('change', function () {
    if (thumbnailSlider) {
  thumbnailSlider.style.display = 'none';
}
    if (productMedia) productMedia.style.display = 'none';
    gallery.querySelectorAll('img').forEach(img => {
      if (!img.closest('#customMugPreview')) {
        img.style.display = 'none';
      }
    });

    if (thumbnails) {
      thumbnails.style.display = 'none';
    }

    preview.style.display = 'block';

    sistersOverlay.style.display = 'none';
    bestiesOverlay.style.display = 'none';

    if (this.value === 'Sisters') {
      sistersOverlay.style.display = 'block';
    }

    if (this.value === 'Besties') {
      bestiesOverlay.style.display = 'block';
    }
  });
});



